export default "__VITE_ASSET__BOhdWacd__"